function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useIsInverseVariant as i } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: e , size: r = 24  } = _param, n = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = i(), c = e !== null && e !== void 0 ? e : t ? o.colors.inverse : o.colors.neutralHigh;
    return /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, n), {
        children: /* @__PURE__ */ a("path", {
            fill: c,
            d: "M19.152 6.558a.41.41 0 00.338.18.41.41 0 00.233-.075.422.422 0 00.105-.58c-1.127-1.655-2.967-3.015-4.93-3.637-2.927-.925-6.1-.329-8.697 1.638A14.102 14.102 0 004.206 5.95a.42.42 0 00.03.588l.009.008a.407.407 0 00.57-.039 13.223 13.223 0 011.88-1.755c2.383-1.81 5.287-2.36 7.96-1.51 1.791.565 3.473 1.806 4.497 3.316zm-5.667 15.42a.368.368 0 01-.098-.012c-1.606-.394-3.256-1.255-4.647-2.428-3.096-2.61-5.571-8.662-2.581-12.585 1.667-2.187 4.628-3.226 7.357-2.588.011 0 4.228.66 5.395 5.558.014.048.44 1.59-.353 2.672-.468.636-1.234.963-2.277.974.018.003-.718.091-1.402-.466-.62-.5-.989-1.343-1.099-2.501-.04-.409-.207-.733-.5-.963-.386-.298-.977-.414-1.585-.31-.184.017-1.516.185-1.632 1.71-.136 1.784 1.243 4.813 4.631 5.649a.415.415 0 01-.193.805c-3.845-.953-5.406-4.455-5.25-6.522.136-1.815 1.596-2.411 2.348-2.47.803-.142 1.61.03 2.184.473.474.37.758.9.818 1.543.084.906.354 1.57.78 1.922.236.201.543.31.852.295.818-.011 1.366-.224 1.673-.642.545-.74.222-1.95.218-1.961-1.045-4.377-4.716-4.95-4.753-4.953-2.468-.574-5.085.34-6.56 2.277-2.654 3.485-.317 9.104 2.457 11.447 1.294 1.09 2.828 1.894 4.313 2.258a.418.418 0 01.304.5.412.412 0 01-.4.318zm.567-2.164a.377.377 0 00.111.016.409.409 0 00.391-.304.413.413 0 00-.283-.51c-2.37-.667-4.517-2.4-5.597-4.518-.823-1.607-.96-3.303-.392-4.913.557-1.686 2.406-2.735 4.294-2.445 1.937.301 3.444 1.96 3.43 3.77a.412.412 0 00.407.422h.001a.414.414 0 00.41-.416c.02-2.214-1.795-4.233-4.126-4.597-2.274-.358-4.515.935-5.194 2.996-.644 1.826-.49 3.749.438 5.566 1.184 2.314 3.526 4.205 6.11 4.933zm-.815-5.126c.802.66 1.804.988 2.993.988a7.737 7.737 0 001.31-.12l.007-.001a.417.417 0 10-.155-.818c-1.522.266-2.749.03-3.635-.694-1.46-1.195-1.568-3.365-1.568-3.388a.416.416 0 00-.425-.397.418.418 0 00-.395.432v.003c.008.142.134 2.57 1.868 3.995z"
        })
    }));
}, g = s;
export { g as default };
